import { ChevronLeft } from '@mui/icons-material';
import { Box, ButtonBase, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';

import GoLogo from '@/components/GoLogo';
import Typography from '@/components/Typography';
import { OnboardingLayout } from '@/layouts/OnboardingLayout';
import useOnboarding from '@/pages/Onboarding/hooks/useOnboarding';
import LoginComponent from '@/pages/Onboarding/LoginComponent';
import useLoginComponent from '@/pages/Onboarding/LoginComponent/useLoginComponent';

const LoginHeader = () => {
  return (
    <>
      <Typography
        size={32}
        sx={{
          mb: {
            xs: 1.5,
            md: 3
          },
          fontWeight: 700,
          textAlign: {
            xs: 'center',
            md: 'left'
          }
        }}
      >
        Welcome to GX Go!
      </Typography>
      <Typography
        size={24}
        sx={{
          mb: {
            xs: 1.25,
            md: 1.5
          },
          fontWeight: 700,
          textAlign: {
            xs: 'center',
            md: 'left'
          }
        }}
      >
        Please enter your email address
      </Typography>
    </>
  );
};
const LoginFooter = () => {
  return (
    <Typography sx={{ fontWeight: 500 }}>
      Not registered yet?{' '}
      <Link
        color='primary.main'
        component={RouterLink}
        rel='noopener noreferrer'
        sx={{ fontWeight: 500, fontSize: 16, pl: 0.5, textDecoration: 'none' }}
        to='../onboarding'
      >
        Sign up for free here
      </Link>
    </Typography>
  );
};
const Login = () => {
  const { logoExpanded, resetPage, status } = useOnboarding();
  const { isLoggedIn } = useLoginComponent();

  return (
    <OnboardingLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          justifyContent: {
            xs: 'center',
            md: 'flex-start'
          }
        }}
      >
        <Box
          sx={{
            display: {
              xs: 'flex',
              md: 'block'
            },
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <GoLogo open={logoExpanded} />
          {!isLoggedIn && !['idle', 'loading', 'onSuppressionList'].includes(status) && (
            <ButtonBase
              sx={{ mt: 3 }}
              onClick={resetPage}
            >
              <ChevronLeft fontSize='small' />
              <Typography variant='subtitle1'>Back</Typography>
            </ButtonBase>
          )}
          <Box
            sx={{
              maxWidth: '550px',
              mt: {
                xs: 2,
                md: 3
              }
            }}
          >
            <LoginComponent
              loginFooter={<LoginFooter />}
              loginHeader={<LoginHeader />}
            />
          </Box>
        </Box>
      </Box>
    </OnboardingLayout>
  );
};

export default Login;
